<template>
  <div :class="bem.b()">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlStepItem' })
const bem = createNamespace('step-item')
</script>
